<ion-content>
  <ion-grid>
    <ion-row>
      <div class="cards-wrapper">
        <ion-col *ngFor="let a of sortedAnnouncements; let i = index; trackBy: trackByFn" size="12" sizeSm="6">
          <ion-card [ngClass]="{ unread: !a.isRead, archived: !a.publishedAt }" (click)="openMessage(a)">
            <ion-card-header class="card-header">
              <header>
                <ion-card-title>
                  <ion-text color="danger" *ngIf="!a.publishedAt">[ARCHIV]</ion-text>
                  {{ a.title }}
                  <ion-icon name="attach-outline" *ngIf="a.attachmentUri"></ion-icon>
                </ion-card-title>
                <ion-card-subtitle>
                  <span class="publishedBy">{{ a.publishedByUser.fullName() }}</span>
                  <span class="publishedAt">{{ a.publishedAt | date: 'd. M. y, H:mm' }}</span>
                </ion-card-subtitle>
              </header>
              <ion-row class="buttonRow">
                <ion-button (click)="$event.stopPropagation(); openPopover($event, a)" fill="clear" color="tertiary">
                  <ion-icon name="ellipsis-vertical"></ion-icon>
                </ion-button>
              </ion-row>
            </ion-card-header>

            <ion-card-content id="body">
              <ng-template [nestedEllipsis]><div [innerHTML]="a.content | bypassHtmlSanitizer"></div></ng-template>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </div>
    </ion-row>
  </ion-grid>
</ion-content>
